export default __webpack_public_path__ + "static/media/FAC2.fa30c663.jpg";